/**
 * The user-facing base segment of a stored programme code.
 *
 * The backend stores `prog_code` composed as `BASE*DEGREE*TYPE*SCHOOL_ID` and
 * recomposes the suffix on every save, so only the base may ever be sent back.
 * Round-tripping the full stored value grows it by one suffix per save until
 * the programme's unique constraint collides (`DMIN` → `DMIN*PHD*…*20` →
 * `DMIN*PHD*…*20*PHD*…*20` → save fails).
 */
export function baseProgCode(code?: string | null): string {
  return ((code ?? '').split('*')[0] ?? '').trim();
}
